import type { CSSProperties } from 'react';

import { cn } from '@/lib/cn';

type SkeletonProps = {
  /** Width (CSS 값: '100%', '200px', '10rem' 등) */
  width?: string | number;
  /** Height (CSS 값: '20px', '2rem' 등) */
  height?: string | number;
  /** 추가 className */
  className?: string;
  /** 추가 inline style */
  style?: CSSProperties;
};

/**
 * 로딩 상태를 표시하는 Skeleton 컴포넌트
 *
 * @example
 * ```tsx
 * <Skeleton width="100%" height="20px" />
 * <Skeleton width={200} height={40} className="rounded-lg" />
 * ```
 */
export const Skeleton = ({
  width,
  height,
  className,
  style,
}: SkeletonProps) => {
  return (
    <div
      className={cn('animate-pulse rounded bg-gray-200', className)}
      style={{
        width,
        height,
        ...style,
      }}
    />
  );
};
